import React from 'react'
import DashboardPanel from "./DashboardPanel";
import {ProgressBar} from "react-step-progress-bar";
import {Link} from "react-router-dom";
import User from "../../../models/User";
import UserImageCircle from "../../../components/UserImageCircle";

const SectionIcons = {
    'Background': "fas fa-id-card",
    'Expertise': "fas fa-award",
    'Work Preferences': "fas fa-clipboard-check",
    'Work Highlights': "fas fa-tasks",
    'Resume': "fas fa-briefcase",
}
export default class ProfilePanel extends DashboardPanel {

    static header = 'talent.dashboard.my_profile_title';
    static LastUpdatedMethod = 'lastUpdatedInfo';

    static is_active = true;

    static columns = 'auto'
    static colClass = 'max-w[calc(100vw_-_1.5rem)] col-availability order-1 w-full mb-6 xl:basis[30%] sm:px-3 md:w-5/12 xl:w3/12'
    static columnProps = {
        xl: 3,
        lg: 5,
        md: 5,
        sm: 12,
        xs: 12
    }
    static columnOrdering = {
        xl: 1,
        lg: 1,
        md: 1,
        sm: 1,
        xs: 1
    }

    renderProgressBanner() {
        let progress = this.context?.auth?.profileProgress();
        return (
            <div className="panel-progress">
                <p className="progress-title">
                    {`${progress}% of setup complete`}
                </p>
                <ProgressBar
                    filledBackground={TB.config('color.light_green')}
                    height={20}
                    percent={progress}
                    unfilledBackground={TB.config('color.backgroundGray')}/>
            </div>
        )
    }

    renderPanel() {

        if (this.isDisabled()) {
            return this.renderDisabled()
        }

        if (this.isInactive()) {
            return this.renderInactive()
        }

        // let completed = this.hasCompletedProfile();

        return (
            <div className={TB.mapClass(
                "talent-dashboard-panel justify-start",
                {
                    'min-width-unset': !TB.isMobile()
                }
            )
            }>


                {this.renderPanelHeader()}

                {this.renderPanelContent()}
            </div>
        )
    }

    renderPanelContent() {

        let auth = this.context?.auth;

        if (!auth) {
            return <div/>;
        }

        let stepSections = TB.groupBy(auth.getFullProfileStepsForTalent(), step => step.StepSection);

        return (
            <div className="talent-panel-content-container">
                <div className="talent-panel-section">

                    <UserImageCircle
                        user={auth}
                        className="rounded-full img-grayscale profile-card-image"
                        hideTooltip={true}
                        size={90}
                        showUnavailable
                    />

                    <div className="flex flex-col items-start h-[90px] justify-end mb-3">
                        <div className="profile-panel-name-title">

                            <p className="leading-normal mb-0.5">{auth.fullName()}</p>
                            <p className="leading-normal mb-0.5">{auth.job_title} </p>

                        </div>

                        {this.props?.onResetAvailability && (
                            auth.hasConfirmedAvailabilityForOpportunities?.() ? (
                                <div className="ml-[15px] flex flex-row gap-2 mt-0.5 items-center">
                                    <i className="fa fa-check text-success font-semibold text-xxs mb-0"/>
                                    <span className="font-semibold text-xxs">Availability set through {auth.confirmedAvailabilityExpiration()?.format?.('ll')}</span>
                                    <button className="ml-auto font-semibold text-xxs px-0 py-0 btn btn-link" onClick={() => this.props.onResetAvailability()}>
                                        Reset
                                    </button>
                                </div>
                            ) : (
                                <div className="ml-[15px] flex flex-row gap-2 mt-0.5 items-center">
                                    <span className="text-danger font-semibold text-xxs mb-0">
                                        !
                                    </span>
                                    <span className="font-semibold text-xxs">Availability Expired</span>
                                    <button className="font-semibold text-xxs px-0 py-0 btn btn-link" onClick={() => this.props.onResetAvailability()}>
                                        Reset
                                    </button>
                                </div>
                            )
                        )}

                    </div>
                </div>

                {this.renderProgressBanner()}

                <div className="row profile-steps-row flex">
                    {TB.chunk(TB.keys(stepSections), TB.ceil(TB.keys(stepSections).length / 2)).map((sections, index) => (
                        <div className="col col-auto profile-steps-progress" key={`profile-sections-${index}`}>
                                {sections.map(sectionKey => {
                                    let steps = stepSections[sectionKey]
                                    const hasCompleted = !TB.filter(steps, section => section.NeedsCompletion?.(auth) !== false && !section.hasCompleted(auth))?.length;
                                    return (
                                        <div className="profile-section-item" key={TB.first(steps).path}>
                                            <i className={TB.mapClass('fas', {
                                                'text-danger fa-times-circle': !hasCompleted,
                                                'text-success fa-check-circle': hasCompleted
                                            })}/>

                                            <Link to={TB.first(steps).getPath()} title={TB.first(steps).StepTitle}>
                                                {sectionKey}
                                            </Link>
                                        </div>
                                    )
                                })}
                            {index ===1 && (
                                <div className="profile-section-item"/>
                            )}
                        </div>
                    ))}
                </div>


                <div className="profile-panel-btns row">


                    <div className="col col-auto">
                        <Link to={`/talent-profiles/${auth.id}`}
                              className="btn btn-link btn-link-dark">
                            {TB.trans('talent.dashboard.profile_overview_buttons.preview')}
                        </Link>

                    </div>

                    <div className="col col-auto">

                        <Link to="/talent/application" className="btn btn-primary">
                            {TB.trans('talent.dashboard.profile_overview_buttons.edit_profile')}
                        </Link>

                    </div>


                </div>
            </div>
        )
    }
}